export const isExisty = (value: any) => value !== undefined && value !== null

export const getCurrentYear = () => {
  return new Date().getFullYear()
}

export const removeWhiteSpace = (input: string) => {
  return input.replace(/\s+/g, '')
}
